import { type DebriefStage } from '@momentum/types';
import { useTranslation } from 'react-i18next';
import { STAGE_META } from '../../gather-facts-stage/utils/stageMeta';

interface DeepDiveChatHeaderProps {
  stage: DebriefStage;
  matchPointIndex: number;
  totalMatchPoints: number;
}

export function DeepDiveChatHeader({
  stage,
  matchPointIndex,
  totalMatchPoints,
}: DeepDiveChatHeaderProps) {
  const { t } = useTranslation('debriefV2');
  const meta = STAGE_META[stage];
  const Icon = meta.icon;

  return (
    <header className="px-5 py-4 border-b border-slate-100 flex items-center bg-white">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-indigo-50 border border-indigo-100/60 flex items-center justify-center shrink-0">
          <Icon className="h-5 w-5 text-indigo-600" aria-hidden />
        </div>
        <div className="flex flex-col justify-center">
          <h3 className="font-semibold text-slate-900 text-[15px] leading-tight">
            {t(meta.labelKey)}
          </h3>
          <p className="text-[12px] font-medium text-slate-400 mt-0.5">
            {t('deepDive.matchPointPosition')(
              matchPointIndex + 1,
              totalMatchPoints
            )}
          </p>
        </div>
      </div>
    </header>
  );
}
